var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('BaseHero',{class:_vm.$style.mainHeading,attrs:{"text":"Favorite Shows"}}),_c('BaseContent',[_c('BaseSection',{attrs:{"padded":""}},[_c('ShowGridBlock',{attrs:{"shows":_vm.showList,"error":{
                    title: `You are not following any shows.`,
                    paragraph: `As you follow shows, they will appear here.`,
                }}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }